import dayjs from 'dayjs';

export function createDefaultCorbanScreeningFilters() {
  const today = dayjs().format('DD/MM/YYYY');

  return {
    name: '',
    status: '',
    begin_date: today,
    end_date: today,
    commercial_id: '',
  };
}

export default {
  filters: createDefaultCorbanScreeningFilters(),
  page: 1,
};
